import React from "react";
import { StepConnector, StepIconProps, styled } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const Connector = styled(StepConnector)({
  "& .MuiStepConnector-line": { borderColor: "#4C3699" },
});

export function CustomStepIcon(props: StepIconProps) {
  const { active, completed } = props;
  return completed ? (
    <CheckIcon style={{ color: "#93f090" }} />
  ) : (
    <div
      style={{
        width: 8,
        height: 8,
        borderRadius: "50%",
        backgroundColor: active ? "#4C3699" : "#ccc",
      }}
    />
  );
}

export { Connector as CustomStepConnector };
